import throttle from 'lodash/throttle';
import getRemBase from 'propel/getRemBase';

const navigationSubMenus = document.querySelectorAll(
	'.block-navigation-submenu'
);
const navigationBackButtons = document.querySelectorAll(
	'.block-navigation-submenu__back-button'
);

// Store the unified offset value
let unifiedOffset = null;

const clickNavigationBackButton = (e) => {
	const currentNavigationBackButton = e.currentTarget;
	const navigationLink = currentNavigationBackButton.closest(
		'.block-navigation-link'
	);

	if (!navigationLink) {
		return;
	}

	navigationLink.classList.remove('active');
};

const setMenuOffset = () => {
	if (0 === navigationSubMenus.length) {
		return;
	}

	// If we already have a unified offset, just apply it
	if (unifiedOffset !== null) {
		navigationSubMenus.forEach((navigationSubMenu) => {
			navigationSubMenu.style.setProperty(
				'--submenuOffset',
				unifiedOffset
			);
		});
		return;
	}

	// First time: calculate offset based on last submenu
	navigationSubMenus.forEach((navigationSubMenu, index) => {
		navigationSubMenu.style.setProperty('--submenuOffset', `0rem`);

		const navigationSubMenuRect = navigationSubMenu.getBoundingClientRect();

		if (0 === navigationSubMenuRect.width || !navigationSubMenuRect.x) {
			return;
		}

		const navigationSubMenuLeft = navigationSubMenuRect.x;
		const navigationSubMenuRight =
			navigationSubMenuRect.x + navigationSubMenuRect.width;
		const navigationBlock = navigationSubMenu.closest(
			'.block-navigation__container'
		);
		let navigationBlockWidth = window.innerWidth;

		if (navigationBlock) {
			const navigationBlockStyles =
				window.getComputedStyle(navigationBlock);
			navigationBlockWidth =
				navigationBlock.offsetWidth -
				parseFloat(navigationBlockStyles['padding-left']) -
				parseFloat(navigationBlockStyles['padding-right']);
		}

		const containerLeft = (window.innerWidth - navigationBlockWidth) / 2;
		const containerRight = containerLeft + navigationBlockWidth;
		let offset = 0;

		if (navigationSubMenuLeft < containerLeft) {
			offset = containerLeft - navigationSubMenuLeft;
		} else if (navigationSubMenuRight > containerRight) {
			offset = containerRight - navigationSubMenuRight;
		}

		// If this is the last submenu, store its offset as the unified offset
		// Disabling this as it's creating the incorrect offset for all menu items.
		// if (index === navigationSubMenus.length - 1) {
		// 	unifiedOffset = `${offset / getRemBase()}rem`;
		// }

		navigationSubMenu.style.setProperty(
			'--submenuOffset',
			`${offset / getRemBase()}rem`
		);
	});

	// Apply unified offset to all submenus
	if (unifiedOffset !== null) {
		navigationSubMenus.forEach((navigationSubMenu) => {
			navigationSubMenu.style.setProperty(
				'--submenuOffset',
				unifiedOffset
			);
		});
	}
};

// Reset unified offset on resize
const handleResize = throttle(() => {
	unifiedOffset = null;
	setMenuOffset();
}, 100);

if (navigationBackButtons.length > 0) {
	navigationBackButtons.forEach((navigationBackButton) => {
		navigationBackButton.addEventListener(
			'click',
			clickNavigationBackButton
		);
	});
}

setMenuOffset();

window.addEventListener('navigation-submenu-opened', setMenuOffset);
window.addEventListener('resize', handleResize);
window.addEventListener('load', setMenuOffset);
